
import axiosClient from "./axiosClient";

const serviceUrl = 'patients-info';

const patientService = {
    getListPatients: async (page = 0, size = 20) => {
        const url = serviceUrl + `/patient/list_patient`;
        const params = { page: 0, size: 20 };
        const response = await axiosClient.get(url, { params: params });
        return response;
    },


};

export default patientService;
